import { render, staticRenderFns } from "./DropdownMenuButton.vue?vue&type=template&id=e9f65b1e"
import script from "./DropdownMenuButton.vue?vue&type=script&lang=js"
export * from "./DropdownMenuButton.vue?vue&type=script&lang=js"
import style0 from "./DropdownMenuButton.vue?vue&type=style&index=0&id=e9f65b1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports